// extracted by mini-css-extract-plugin
export default {"color-black":"homepage_color-black__-bEFD","color-purple":"homepage_color-purple__vprHT","root":"homepage_root__QYQKf","section":"homepage_section__AQ7SY"};